import pickerTemplate from './language_picker.html';

function LanguagePickerCtrl($rootScope, $scope, bbLocale, tmhDynamicLocale, bbi18nOptions) {
    'ngInject';

    /*jshint validthis: true */

    const languages = bbi18nOptions.available_languages;
    this.language = null;
    this.availableLanguages = [];
    this.setAvailableLanguages = setAvailableLanguages;
    this.setCurrentLanguage = setCurrentLanguage;
    this.setLanguage = setLanguage;

    (() => {
        this.setAvailableLanguages();
        this.setCurrentLanguage();
        $scope.$on('BBLanguagePicker:refresh', setCurrentLanguage);
        this.pickLanguage = pickLanguage;
    })();

    function setAvailableLanguages() {
        languages.forEach((languageKey) => {
            this.availableLanguages.push(createLanguage(languageKey));
        });
    }

    function setCurrentLanguage() {
        tmhDynamicLocale
            .set(bbLocale.getLocale())
            .then(() => {
                this.language = { selected: createLanguage(bbLocale.getLocale()) };
            });
    }

    /*
     * @param {String]
     */
    function createLanguage(languageKey) {
        return {
            identifier: languageKey,
            label: `COMMON.LANGUAGE.${languageKey.toUpperCase()}`
        };
    }

    function setLanguage(lang){
        this.language.selected = lang;
        this.pickLanguage(lang.identifier);
    }

    /*
     * @param {String]
     */
    function pickLanguage(languageKey) {
        tmhDynamicLocale.set(languageKey).then( () => {
            bbLocale.setLocale(languageKey, 'bbLanguagePicker.pickLanguage');
            $rootScope.$broadcast('BBLanguagePicker:languageChanged');
        });
    }
}

function languagePickerLink(scope, element, attrs) {

    if (scope.vm.availableLanguages.length <= 1) {
        angular.element(element).addClass('hidden');
    }
}

/**
 * @ngdoc directive
 * @name BB.i18n:bbLanguagePicker
 * @scope
 * @restrict A
 *
 * @description
 * Responsible for providing a ui representation of available translations
 *
 */
function LanguagePicker() {

    return {
        controller: LanguagePickerCtrl,
        controllerAs: 'vm',
        restrict: 'A',
        scope: true,
        link: languagePickerLink,
        templateUrl: pickerTemplate.id
    };

}

export default LanguagePicker;

angular
    .module('BB.i18n')
    .directive('bbLanguagePicker', LanguagePicker);


// WEBPACK FOOTER //
// ../node_modules/bookingbug-angular/src/core/-i18n/language-picker/language_picker.directive.js